//import libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import language
import { SettingsListLangForm, SettingsEditLangForm, SettingsSettingsLang } from '../languages/Settings.Lang';

//import services
import { GeneralService } from '../services/general.service';

//import classes
import {
    SettingsFormMangIn, SettingsFormMangOut
  } from '../classes/settings.model';

@Injectable()

export class SettingsService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) { }

    resolve() {
        return this.FetchDetails();
    }

    FetchDetails(): Observable<any> {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsData;
        return this.http.get<any>(url);

    }

    getlistLangForm(details: any) {

        if (!details) return;

        let instance = new SettingsListLangForm(details.language);
        return instance.lang();

    }

    getEditLangForm(details: any) {

        if (!details) return;

        let instance = new SettingsEditLangForm(details.language);
        return instance.lang();

    }

    getSettingsLang(details: any) {

        if (!details) return;

        let instance = new SettingsSettingsLang(details.language);
        return instance.lang();

    }

    // FormMangServCall(input : SettingsFormMangIn) {
    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
    //     return this.http.post<SettingsFormMangOut>(url, input);
    // }

    FormMangServCall(input : SettingsFormMangIn) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
        if(input.action == 'view')
            return this.http.post<SettingsFormMangOut>(url, input, {  responseType: 'blob' as 'json' });
        else
            return this.http.post<SettingsFormMangOut>(url, input);
    }

    FormMangUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
        return this.http.post<any>(url, data);
    }

    settingsUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsSettings;
        return this.http.post<any>(url, data);
    }


}